import React from 'react';
import {IShippingOption} from '../../i';
import {CarrierLogo, formatShipDates, parseShipDesc} from '../ab-step/ab-redesign-ship-carrier';

export const SHIP_METHOD_RADIO_NAME = 'checkout-ship-method';

export const getShipMethodRadioId = (key: number): string => `ship-option-${key}`;

type ShipMethodRadioGroupProps = {
    options: IShippingOption[];
    selectedKey: number | undefined;
    onSelect: (option: IShippingOption) => void;
    disabled?: boolean;
};

export const ShipMethodRadioGroupRedesign: React.FC<ShipMethodRadioGroupProps> = ({options, selectedKey, onSelect, disabled}) => {
    return (
        <>
            <legend className="sr-only">Select Your Shipping Speed</legend>
            {options.map(o => {
                const id = getShipMethodRadioId(o.key);
                const selected = selectedKey != undefined && o.key === selectedKey;
                const parts = parseShipDesc(o.desc);
                return (
                    <label
                        key={o.key}
                        className={`ab-ship-opt${selected ? ' is-selected' : ''}`}
                        htmlFor={id}
                    >
                        <input
                            type="radio"
                            name={SHIP_METHOD_RADIO_NAME}
                            id={id}
                            value={String(o.key)}
                            checked={selected}
                            disabled={disabled}
                            onChange={event => {
                                if (event.target.checked) {
                                    onSelect(o);
                                }
                            }}
                        />
                        <span
                            className="ab-ship-opt-mark"
                            aria-hidden={true}
                        >
                            {selected && <i className="fas fa-check" />}
                        </span>
                        <span className="ab-ship-opt-body">
                            <span className="ab-ship-opt-title">
                                <CarrierLogo carrier={parts.carrier} />
                                {parts.service}. Arrives by {formatShipDates(o.dates)}
                            </span>
                            {parts.production && <span className="ab-ship-opt-sub">{parts.production}</span>}
                        </span>
                        <span className="ab-ship-opt-price">{o.price}</span>
                    </label>
                );
            })}
        </>
    );
};

export const ShipMethodRadioGroup: React.FC<ShipMethodRadioGroupProps> = ({options, selectedKey, onSelect, disabled}) => {
    return (
        <>
            <legend className="ship-methods-header">Select Your Shipping Speed</legend>
            {options.map(o => {
                const id = getShipMethodRadioId(o.key);
                return (
                    <label
                        key={o.key}
                        className="ship-method radio-container"
                        htmlFor={id}
                    >
                        <div>
                            <input
                                type="radio"
                                className="radio"
                                name={SHIP_METHOD_RADIO_NAME}
                                id={id}
                                value={String(o.key)}
                                checked={selectedKey != undefined && o.key === selectedKey}
                                disabled={disabled}
                                onChange={event => {
                                    if (event.target.checked) {
                                        onSelect(o);
                                    }
                                }}
                            />
                        </div>
                        <div className="ship-desc">
                            <div className="dates">Get it by {o.dates.replace('By ', '')}</div>
                            <div className="desc">{o.desc}</div>
                        </div>
                        <div className="price">{o.price}</div>
                    </label>
                );
            })}
        </>
    );
};
